export default "__VITE_ASSET__Ds47AH5I__"